import { render, staticRenderFns } from "./ListaInsumosFoodcourt.vue?vue&type=template&id=78a567c2&scoped=true"
import script from "./ListaInsumosFoodcourt.vue?vue&type=script&lang=js"
export * from "./ListaInsumosFoodcourt.vue?vue&type=script&lang=js"
import style0 from "./ListaInsumosFoodcourt.vue?vue&type=style&index=0&id=78a567c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a567c2",
  null
  
)

export default component.exports